import React from 'react';
import { logInfo } from '../../utils/utils';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import appConfig from '../../app-config';

import './header.scss';

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pages: props.pages,
    }

    this.userPanelContextRef = React.createRef();
  }

  render() {
    const { userMenuItems, userFullName } = this.props;
    const expand = true;
    
    return (<header className={'header-component'}>
      <Navbar
        expand={false}
        className='bg-body-tertiary mb-3'
      >
        <Container fluid>
          <Navbar.Brand href='/' className="mx-auto">{appConfig.app.title}</Navbar.Brand>          <NavDropdown
            title={`Hello, ${userFullName}`}
            id={`offcanvasNavbarDropdown-expand-${expand}`}
            align='end'
          >
            {userMenuItems.map((item) => (
              <>
                {(item.divide && <NavDropdown.Divider />)}
                <NavDropdown.Item
                  href={item.path}
                  onClick={() => item.onClick({
                    path: item.path,
                    text: item.text,
                  })}
                >
                  {item.text}
                </NavDropdown.Item>
              </>
            ))}
          </NavDropdown>
        </Container>
      </Navbar>
    </header>);
  }

  refresh(ref) {
    logInfo(`Refresh command for '${ref}' in 'Header'`);
    if (ref === 'user-panel') {
      this.userPanelContextRef.current.loadUserInfo();
    }
  }
}